<template>
  <div id="PurchaseRecordMgmt" class="purchase-mgmt-page">
    <div class="page-header">
      <div class="filter-card header-box">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">视图类型</span>
            <el-select placeholder="视图类型" size="small" v-model="params.viewType">
              <el-option label="产品" value="2"></el-option>
              <el-option label="SKU" value="1"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品类型</span>
            <el-select class="filter-select-wide" placeholder="全部" size="small" @change="onProductTypeChange" v-model="productTypeList" filterable multiple collapse-tags clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品颜色</span>
            <el-select placeholder="全部" size="small" v-model="params.productColor" filterable clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">机型</span>
            <el-select placeholder="全部" size="small" v-model="productModel" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">SKU</span>
            <el-input placeholder="请输入SKU" size="small" clearable v-model="params.sku" class="filter-input-wide"></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">采购供应商</span>
            <el-select class="filter-select-wide" placeholder="全部" size="small" @change="onSupplierIdChange" v-model="supplierIdList" filterable multiple collapse-tags clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="supplier in supplierList" :key="supplier.supplierId" :label="supplier.supplierShortName" :value="supplier.supplierId"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">采购日期</span>
            <el-date-picker v-model="date" size="small" type="daterange" range-separator="至" start-placeholder="开始" end-placeholder="结束" :picker-options="pickerOptions" class="filter-date"></el-date-picker>
          </div>
          <div class="filter-item">
            <span class="filter-label">收货标识</span>
            <el-select placeholder="全部" size="small" v-model="params.fulfillmentCloseFlag" clearable>
              <el-option v-for="opt in fulfillmentCloseFilterOptions" :key="opt.value || 'all'" :label="opt.label" :value="opt.value"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">商品类型</span>
            <el-select placeholder="全部" size="small" v-model="params.purchaseProductType" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="产品" :value="1"></el-option>
              <el-option label="纸箱" :value="2"></el-option>
              <el-option label="花熊链子" :value="3"></el-option>
              <el-option label="材料" :value="4"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <el-button type="primary" size="small" icon="el-icon-search" @click="queryBtn">查询</el-button>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="addBtn">新增</el-button>
            <el-button size="small" icon="el-icon-upload2" @click="importBtn">导入</el-button>
          </div>
        </div>

        <div class="batch-toolbar" v-if="multipleSelection.length > 0">
          <el-button v-if="hasConfirmableSelection" type="primary" size="small" class="toolbar-action-btn" :loading="actionLoading" @click="onConfirmClick">确认采购</el-button>
          <el-button v-if="hasCreatableSelection" type="primary" size="small" class="toolbar-action-btn action-btn-long-label action-btn-create-purchase-order" :loading="actionLoading" @click="onCreatePurchaseOrderClick">创建采购单</el-button>
          <el-button v-if="hasRejectableSelection" type="warning" plain size="small" class="toolbar-action-btn" :loading="actionLoading" @click="onRejectClick">打回</el-button>
          <el-button v-if="hasVoidableSelection" type="danger" plain size="small" class="toolbar-action-btn" :loading="actionLoading" @click="onVoidClick">作废</el-button>
          <el-button type="primary" size="small" plain class="toolbar-action-btn" @click="exportProductBtn">导出</el-button>
          <el-button type="primary" size="small" plain class="toolbar-action-btn" @click="exportMaterialBtn">导出材料</el-button>
          <el-button size="small" class="toolbar-action-btn" @click="cancelSelected">取消选中</el-button>
          <span class="toolbar-tip">已选 {{ multipleSelection.length }} 条</span>
        </div>
      </div>
    </div>

    <div class="table-panel" ref="tablePanel">
      <el-tabs v-model="activeStatusTab" class="status-tabs" @tab-click="onStatusTabChange">
        <el-tab-pane v-for="tab in statusTabs" :key="tab.name" :name="tab.name">
          <span slot="label" class="status-tab-label">{{ tab.label }}</span>
        </el-tab-pane>
      </el-tabs>
      <div class="fulfillment-tip">入库 / 质检 / 缺货 / 多到及退货退款状态以采购单明细为准；待确认、待采购阶段显示为 0。「收货标识」：绿色已结案，橙色数量齐待结案，红色数量不一致（入库不足/入库超采）</div>

      <div class="table-container">
        <el-table ref="table" :key="'purchase-record-' + params.viewType" :data="tableData" border stripe size="mini" :height="screenHeight" v-loading="loading" element-loading-text="加载中..." show-summary :summary-method="getTableSummaries" header-cell-class-name="table-header-cell" class="mgmt-table" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="48" align="center" fixed="left"></el-table-column>
          <el-table-column label="序号" width="50" align="center" fixed="left">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="date" label="采购日期" width="100" align="center" fixed="left" sortable></el-table-column>
          <el-table-column prop="shopName" label="店铺名称" width="80" align="center" fixed="left" show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplierName" label="采购供应商" width="120" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productName" label="产品名称" width="200" show-overflow-tooltip></el-table-column>
          <el-table-column v-if="params.viewType == 1" prop="sku" label="SKU" width="180" show-overflow-tooltip></el-table-column>
          <el-table-column v-if="params.viewType == 1" prop="purchaseColorName" label="颜色" width="80" align="center" sortable></el-table-column>
          <el-table-column v-if="params.viewType == 1" prop="model" label="型号" width="90" align="center" sortable></el-table-column>
          <el-table-column prop="purchaseQuantity" label="采购数量" width="90" align="right" sortable></el-table-column>
          <el-table-column prop="arrived" label="入库数量" width="90" align="right" sortable>
            <template slot="header">
              <span title="以采购单明细履约为准（联查 purchaseOrderLine）">入库数量</span>
            </template>
          </el-table-column>
          <el-table-column prop="qualityFail" label="质检不合格数量" width="120" align="right" sortable>
            <template slot="header">
              <span title="以采购单明细履约为准（联查 purchaseOrderLine）">质检不合格数量</span>
            </template>
          </el-table-column>
          <el-table-column prop="outOfStock" label="缺货数量" width="90" align="right" sortable>
            <template slot="header">
              <span title="以采购单明细履约为准（联查 purchaseOrderLine）">缺货数量</span>
            </template>
          </el-table-column>
          <el-table-column prop="overStock" label="到多数量" width="90" align="right" sortable>
            <template slot="header">
              <span title="以采购单明细履约为准（联查 purchaseOrderLine）">到多数量</span>
            </template>
          </el-table-column>
          <el-table-column prop="fulfillmentCloseLabel" label="收货标识" width="140" align="center">
            <template slot="header">
              <span title="绿色已结案，橙色数量齐待结案，红色数量不一致">收货标识</span>
            </template>
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.fulfillmentCloseFlag"
                :type="getFulfillmentCloseTagType(scope.row.fulfillmentCloseFlag)"
                size="mini"
              >
                {{ scope.row.fulfillmentCloseLabel }}
              </el-tag>
              <span v-else class="fulfillment-flag-empty">—</span>
            </template>
          </el-table-column>
          <el-table-column prop="purchaseStatusLabel" label="采购状态" width="100" align="center" sortable></el-table-column>
          <el-table-column prop="refundStatusLabel" label="退款状态" width="100" align="center" sortable></el-table-column>
          <el-table-column prop="returnStatusLabel" label="退货状态" width="100" align="center" sortable></el-table-column>
          <el-table-column prop="orderNo" label="采购单号" width="170" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="300" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="canEdit(scope.row)" type="text" size="mini" @click="onEditRow(scope.row)">编辑</el-button>
              <el-button v-if="canConfirm(scope.row)" type="text" size="mini" @click="onConfirmRow(scope.row)">确认采购</el-button>
              <el-button v-if="canCreateOrder(scope.row)" type="text" size="mini" @click="onCreatePurchaseOrderRow(scope.row)">创建采购单</el-button>
              <el-button v-if="canReject(scope.row)" type="text" size="mini" class="warning-text" @click="onRejectRow(scope.row)">打回</el-button>
              <el-button v-if="canVoid(scope.row)" type="text" size="mini" class="danger-text" @click="onVoidRow(scope.row)">作废</el-button>
              <el-button type="text" size="mini" @click="showOpreateLog(scope.row)">操作记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-box">
        <el-pagination layout="prev, pager, next" background prev-text="上一页" next-text="下一页" :current-page.sync="currentPage" :page-size="params.pageSize" :total="total" @current-change="onPageChange"></el-pagination>
      </div>
    </div>

    <create-purchase-order-dialog ref="createOrderDialog" :supplier-list="supplierList" @success="onCreatePurchaseOrderSuccess"></create-purchase-order-dialog>
    <create-manual-purchase-record-dialog ref="manualAddDialog" :supplier-list="supplierList" @success="onManualAddSuccess"></create-manual-purchase-record-dialog>

    <el-dialog title="导入" :visible.sync="dialogImportVisible" width="35%">
      <el-form>
        <el-form-item label="导入采购记录" label-width="100">
          <el-upload
            ref="uploadPurchaseRecord"
            class="upload-demo"
            action="/node/importPurchaseRecord"
            accept=".xlsm,.xlsx"
            :auto-upload="false"
            :on-success="onImportSuccess"
            :on-error="onImportError"
            :limit="1"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">支持 xlsm / xlsx，数量取「应采购」，店铺以 SKU 主数据为准，已存在同日同 SKU 将跳过</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogImportVisible = false">取 消</el-button>
        <el-button type="primary" :loading="importLoading" @click="importData">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="打回采购记录" :visible.sync="rejectVisible" width="480px" :close-on-click-modal="false">
      <el-form label-width="80px">
        <el-form-item label="备注原因" required>
          <el-input v-model="rejectRemark" type="textarea" :rows="4" maxlength="500" show-word-limit placeholder="请填写打回备注原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectVisible = false">取 消</el-button>
        <el-button type="primary" :loading="actionLoading" @click="confirmReject">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="操作记录" :visible.sync="opreateLogVisible" width="960px">
      <el-table :data="operateHistory" border stripe size="mini" max-height="420" v-loading="opreateLogLoading">
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="opreateUserName" label="操作人" width="90"></el-table-column>
        <el-table-column prop="opreateTimeLabel" label="操作时间" width="170"></el-table-column>
        <el-table-column prop="opreateTypeLabel" label="操作类型" width="120"></el-table-column>
        <el-table-column prop="bussinessId" label="业务ID" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="操作详情" min-width="240" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="opreateLogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导出" :visible.sync="dialogExportVisible" width="920px">
      <el-table :data="exportDataList" stripe size="mini" :highlight-current-row="true" show-summary>
        <el-table-column label="序号" width="60px" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="date" label="采购日期" width="100px" align="center"></el-table-column>
        <el-table-column prop="productName" label="产品名称" width="150px"></el-table-column>
        <el-table-column prop="purchaseColorName" label="产品颜色" width="80px"></el-table-column>
        <el-table-column prop="model" label="机型" width="80px"></el-table-column>
        <el-table-column prop="boxSpec" label="规格" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="planPurchase" label="应采购数量" width="80px" align="right"></el-table-column>
        <el-table-column prop="alreadyPurchased" label="已采购数量" width="80px" align="right"></el-table-column>
        <el-table-column prop="arrived" label="已到货数量" width="80px" align="right"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogExportVisible = false">关 闭</el-button>
        <el-button class="opreate-btn" type="primary" size="small"><download-excel :data="exportDataList" :fields="exportTitles" :name="getExportName()">采购导出</download-excel></el-button>
        <el-button class="opreate-btn" type="primary" size="small"><download-excel :data="exportStoreDataList" :fields="exportStoreTitles" :name="getExportName()">仓库导出</download-excel></el-button>
      </div>
    </el-dialog>

    <el-dialog title="导出材料" :visible.sync="dialogExportMaterialVisible" width="920px">
      <el-table :data="exportMaterialDataList" stripe size="mini" :highlight-current-row="true" show-summary v-loading="exportMaterialLoading" element-loading-text="加载中...">
        <el-table-column label="序号" width="60px" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="date" label="采购日期" width="100px" align="center"></el-table-column>
        <el-table-column prop="materialName" label="材料名称" width="150px"></el-table-column>
        <el-table-column prop="purchaseColorName" label="采购颜色" width="80px"></el-table-column>
        <el-table-column prop="model" label="机型" width="80px"></el-table-column>
        <el-table-column prop="boxSpec" label="规格" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="planPurchase" label="应采购数量" width="80px" align="right"></el-table-column>
        <el-table-column prop="alreadyPurchased" label="已采购数量" width="80px" align="right"></el-table-column>
        <el-table-column prop="arrived" label="已到货数量" width="80px" align="right"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogExportMaterialVisible = false">关 闭</el-button>
        <el-button class="opreate-btn" type="primary" size="small"><download-excel :data="exportMaterialDataList" :fields="exportMaterialTitles" :name="getExportMaterialName()">材料导出</download-excel></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { activeProducts, allActiveProducts, colors, models } from "../../utils/constant.js";
import { PURCHASE_RECORD_STATUS, STATUS_TABS, FULFILLMENT_CLOSE_FILTER_OPTIONS, canVoidPurchaseRecord, canConfirmPurchaseRecord, canCreatePurchaseOrder, canRejectPurchaseRecord, canEditPurchaseRecord, getFulfillmentCloseTagType } from "./purchaseRecordStatus.js";
import CreatePurchaseOrderDialog from "./CreatePurchaseOrderDialog.vue";
import CreateManualPurchaseRecordDialog from "./CreateManualPurchaseRecordDialog.vue";

export default {
  name: "PurchaseRecordMgmt",
  components: {
    CreatePurchaseOrderDialog,
    CreateManualPurchaseRecordDialog,
  },
  data() {
    return {
      loading: false,
      actionLoading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      screenHeight: document.body.clientHeight - 64 - 120 - 100,
      productList: localStorage.getItem("shopType") == 6 ? allActiveProducts : activeProducts,
      colorList: colors,
      modelList: models,
      supplierList: [],
      activeStatusTab: String(PURCHASE_RECORD_STATUS.PENDING_CONFIRM),
      statusTabs: STATUS_TABS,
      fulfillmentCloseFilterOptions: FULFILLMENT_CLOSE_FILTER_OPTIONS,
      multipleSelection: [],
      productTypeList: [],
      supplierIdList: [],
      productModel: "",
      date: [],
      rejectVisible: false,
      rejectRemark: "",
      rejectRows: [],
      opreateLogVisible: false,
      opreateLogLoading: false,
      operateHistory: [],
      dialogExportVisible: false,
      dialogExportMaterialVisible: false,
      dialogImportVisible: false,
      importLoading: false,
      exportDataList: [],
      exportStoreDataList: [],
      exportMaterialDataList: [],
      exportMaterialLoading: false,
      params: {
        viewType: "2",
        productTypeList: "[]",
        supplierIdList: "[]",
        productColor: "",
        productModel: "",
        sku: "",
        purchaseProductType: "",
        fulfillmentCloseFlag: "",
        beginIndex: 0,
        pageSize: 1000,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    hasConfirmableSelection() {
      return (this.multipleSelection || []).some(row => this.canConfirm(row));
    },
    hasCreatableSelection() {
      return (this.multipleSelection || []).some(row => this.canCreateOrder(row));
    },
    hasRejectableSelection() {
      return (this.multipleSelection || []).some(row => this.canReject(row));
    },
    hasVoidableSelection() {
      return (this.multipleSelection || []).some(row => this.canVoid(row));
    },
    exportTitles() {
      return {
        采购日期: "date",
        SKU: "sku",
        产品名称: "productName",
        颜色: "purchaseColorName",
        机型: "model",
        规格: "boxSpec",
        应采购数量: "planPurchase",
        已采购数量: "alreadyPurchased",
        已到货数量: "arrived",
      };
    },
    exportStoreTitles() {
      return {
        店铺: "shopName",
        采购日期: "date",
        SKU: "sku",
        FNSKU: "fnsku",
        产品名称: "productName",
        颜色: "purchaseColorName",
        机型: "model",
        规格: "boxSpec",
        应采购数量: "planPurchase",
        已采购数量: "alreadyPurchased",
        已到货数量: "arrived",
      };
    },
    exportMaterialTitles() {
      return {
        采购日期: "date",
        材料名称: "materialName",
        采购颜色: "purchaseColorName",
        机型: "model",
        规格: "boxSpec",
        应采购数量: "planPurchase",
        已采购数量: "alreadyPurchased",
        已到货数量: "arrived",
      };
    },
  },
  mounted() {
    this.fetchSuppliers();
    this.relayoutTable();
    this.getData();
    this.$eventBus && this.$eventBus.$on && this.$eventBus.$on("resize", this.relayoutTable);
    window.addEventListener("resize", this.relayoutTable);
  },
  beforeDestroy() {
    this.$eventBus && this.$eventBus.$off && this.$eventBus.$off("resize", this.relayoutTable);
    window.removeEventListener("resize", this.relayoutTable);
  },
  watch: {
    productModel: {
      handler(newValue) {
        const blankReg = new RegExp(" ", "igm");
        this.params.productModel = (newValue || "").replace(blankReg, "");
      },
    },
    "params.viewType": {
      handler(newValue) {
        this.params.pageSize = newValue == 1 ? 200 : 1000;
        this.onPageChange(1);
      },
    },
    "multipleSelection.length"() {
      this.relayoutTable();
    },
  },
  methods: {
    getFulfillmentCloseTagType,
    getTableSummaries({ columns, data }) {
      const sumProps = ["purchaseQuantity", "arrived", "qualityFail", "outOfStock", "overStock"];
      const sums = [];
      columns.forEach((column, index) => {
        if (column.type === "selection") {
          sums[index] = "";
          return;
        }
        if (column.label === "序号") {
          sums[index] = "合计";
          return;
        }
        if (sumProps.includes(column.property)) {
          sums[index] = (data || []).reduce((sum, row) => sum + (Number(row[column.property]) || 0), 0);
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
    canVoid(row) {
      if (!row) return false;
      if (Array.isArray(row.purchaseStatuses) && row.purchaseStatuses.length) {
        return row.purchaseStatuses.every(status => canVoidPurchaseRecord(status));
      }
      return canVoidPurchaseRecord(row.purchaseStatus);
    },
    canConfirm(row) {
      if (!row) return false;
      if (Array.isArray(row.purchaseStatuses) && row.purchaseStatuses.length) {
        return row.purchaseStatuses.every(status => canConfirmPurchaseRecord(status));
      }
      return canConfirmPurchaseRecord(row.purchaseStatus);
    },
    canCreateOrder(row) {
      if (!row) return false;
      if (Array.isArray(row.purchaseStatuses) && row.purchaseStatuses.length) {
        return row.purchaseStatuses.every(status => canCreatePurchaseOrder(status));
      }
      return canCreatePurchaseOrder(row.purchaseStatus);
    },
    canReject(row) {
      if (!row) return false;
      if (Array.isArray(row.purchaseStatuses) && row.purchaseStatuses.length) {
        return row.purchaseStatuses.every(status => canRejectPurchaseRecord(status));
      }
      return canRejectPurchaseRecord(row.purchaseStatus);
    },
    canEdit(row) {
      if (!row) return false;
      if (this.params.viewType != 1) return false;
      if (Array.isArray(row.purchaseIds) && row.purchaseIds.length > 1) return false;
      return canEditPurchaseRecord(row.purchaseStatus);
    },
    fetchSuppliers() {
      requestModules.fetchSuppliers({ beginIndex: 0, pageSize: 1000 }).then(res => {
        this.supplierList = res.ldata || [];
      });
    },
    calculateHeight() {
      const panel = this.$refs.tablePanel;
      if (!panel) return;
      const tabs = panel.querySelector(".status-tabs");
      const pagination = panel.querySelector(".pagination-box");
      const panelStyle = window.getComputedStyle(panel);
      const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
      const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
      const available = panel.clientHeight - paddingTop - paddingBottom - (tabs ? tabs.offsetHeight + 12 : 0) - (pagination ? pagination.offsetHeight : 0);
      this.screenHeight = Math.max(available, 200);
    },
    relayoutTable() {
      this.$nextTick(() => {
        this.calculateHeight();
        this.$nextTick(() => {
          if (this.$refs.table && this.$refs.table.doLayout) {
            this.$refs.table.doLayout();
          }
        });
      });
    },
    onProductTypeChange(checkList) {
      let isAllChecked = false;
      checkList.forEach(productType => productType == "" && (isAllChecked = true));
      if (isAllChecked) {
        this.productTypeList = [];
        this.productList.forEach(product => this.productTypeList.push(product.productType));
      }
    },
    onSupplierIdChange(checkList) {
      let isAllChecked = false;
      checkList.forEach(supplierId => supplierId == "" && (isAllChecked = true));
      if (isAllChecked) {
        this.supplierIdList = [];
        this.supplierList.forEach(supplier => this.supplierIdList.push(String(supplier.supplierId)));
      }
    },
    queryBtn() {
      this.currentPage = 1;
      this.params.beginIndex = 0;
      this.getData();
    },
    onStatusTabChange(tab) {
      this.activeStatusTab = tab.name;
      this.currentPage = 1;
      this.params.beginIndex = 0;
      this.cancelSelected();
      this.getData();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.params.beginIndex = (page - 1) * this.params.pageSize;
      this.getData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },
    cancelSelected() {
      this.multipleSelection = [];
      this.$refs.table && this.$refs.table.clearSelection();
    },
    onVoidRow(row) {
      this.doVoid([row]);
    },
    onVoidClick() {
      const rows = (this.multipleSelection || []).filter(row => this.canVoid(row));
      if (!rows.length) {
        this.$message.warning("请选择待确认或待采购状态的采购记录");
        return;
      }
      this.doVoid(rows);
    },
    onConfirmRow(row) {
      this.doConfirm([row]);
    },
    onEditRow(row) {
      if (!this.canEdit(row)) {
        this.$message.warning("仅 SKU 视图下待确认状态的单条记录可编辑采购数量");
        return;
      }
      this.$prompt("请输入采购数量", "编辑采购数量", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: String(row.purchaseQuantity != null ? row.purchaseQuantity : ""),
        inputPattern: /^[1-9]\d*$/,
        inputErrorMessage: "请输入正整数",
      })
        .then(({ value }) => {
          if (this.actionLoading) return;
          this.actionLoading = true;
          requestModules
            .updatePurchaseRecordQuantity({
              _id: row._id,
              purchaseQuantity: value,
            })
            .then(res => {
              if (res.result !== 1) {
                this.$message.error(res.message || "编辑失败");
                return;
              }
              this.$message.success("采购数量已更新");
              this.getData();
            })
            .catch(() => {
              this.$message.error("编辑失败");
            })
            .finally(() => {
              this.actionLoading = false;
            });
        })
        .catch(() => {});
    },
    onConfirmClick() {
      const rows = (this.multipleSelection || []).filter(row => this.canConfirm(row));
      if (!rows.length) {
        this.$message.warning("请选择待确认状态的采购记录");
        return;
      }
      this.doConfirm(rows);
    },
    onCreatePurchaseOrderRow(row) {
      this.openCreatePurchaseOrderDialog([row]);
    },
    onCreatePurchaseOrderClick() {
      const rows = (this.multipleSelection || []).filter(row => this.canCreateOrder(row));
      if (!rows.length) {
        this.$message.warning("请选择待采购状态的采购记录");
        return;
      }
      this.openCreatePurchaseOrderDialog(rows);
    },
    onRejectRow(row) {
      this.openRejectDialog([row]);
    },
    onRejectClick() {
      const rows = (this.multipleSelection || []).filter(row => this.canReject(row));
      if (!rows.length) {
        this.$message.warning("请选择待采购状态的采购记录");
        return;
      }
      this.openRejectDialog(rows);
    },
    openRejectDialog(rows) {
      this.rejectRows = rows || [];
      this.rejectRemark = "";
      this.rejectVisible = true;
    },
    confirmReject() {
      if (!this.rejectRemark || !this.rejectRemark.trim()) {
        this.$message.error("请填写打回备注原因");
        return;
      }
      if (this.actionLoading) return;
      this.actionLoading = true;
      requestModules
        .rejectPurchaseRecords({
          selectedList: JSON.stringify(this.rejectRows),
          remark: this.rejectRemark.trim(),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "打回失败");
            return;
          }
          this.$message.success("已打回至待确认");
          this.rejectVisible = false;
          this.rejectRows = [];
          this.cancelSelected();
          this.getData();
        })
        .catch(() => {
          this.$message.error("打回失败");
        })
        .finally(() => {
          this.actionLoading = false;
        });
    },
    openCreatePurchaseOrderDialog(rows) {
      this.$refs.createOrderDialog && this.$refs.createOrderDialog.open(rows);
    },
    onCreatePurchaseOrderSuccess() {
      this.cancelSelected();
      this.getData();
    },
    resolveRecordIds(row) {
      if (!row) return [];
      if (Array.isArray(row.purchaseIds) && row.purchaseIds.length) {
        return [...new Set(row.purchaseIds.map(id => String(id)).filter(Boolean))];
      }
      return row._id ? [String(row._id)] : [];
    },
    fetchOpreateLogsByBusinessId(bussinessId) {
      return requestModules
        .fetchOpreateLogs({
          startTime: 0,
          endTime: new Date().getTime(),
          bussinessId,
          beginIndex: 0,
          pageSize: 1000,
        })
        .then(res => {
          if (res.result !== 1) {
            return Promise.reject(new Error(res.message || "获取操作记录失败"));
          }
          return res.ldata || [];
        });
    },
    showOpreateLog(row) {
      const ids = this.resolveRecordIds(row);
      if (!ids.length) {
        this.$message.warning("缺少采购记录ID");
        return;
      }
      this.operateHistory = [];
      this.opreateLogVisible = true;
      this.opreateLogLoading = true;
      Promise.all(ids.map(id => this.fetchOpreateLogsByBusinessId(id)))
        .then(lists => {
          const merged = [];
          const seen = new Set();
          (lists || []).forEach(list => {
            (list || []).forEach(item => {
              const key = item.opreateLogId != null ? String(item.opreateLogId) : `${item.opreateTime}_${item.content}`;
              if (seen.has(key)) return;
              seen.add(key);
              merged.push(item);
            });
          });
          merged.sort((a, b) => (Number(b.opreateTime) || 0) - (Number(a.opreateTime) || 0));
          this.operateHistory = merged;
          if (!merged.length) {
            this.$message.info("暂无操作记录");
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取操作记录失败");
        })
        .finally(() => {
          this.opreateLogLoading = false;
        });
    },
    buildExportSelectedList() {
      return (this.multipleSelection || [])
        .map(row => {
          const purchaseIds = this.resolveRecordIds(row);
          if (purchaseIds.length > 1) {
            return { purchaseIds };
          }
          if (purchaseIds.length === 1) {
            return { _id: purchaseIds[0] };
          }
          return null;
        })
        .filter(Boolean);
    },
    getExportParams() {
      return {
        selectedList: JSON.stringify(this.buildExportSelectedList()),
      };
    },
    getExportName() {
      return "采购计划表_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
    getExportMaterialName() {
      return "采购材料表_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
    importBtn() {
      this.dialogImportVisible = true;
      this.$nextTick(() => {
        this.clearImportFiles();
      });
    },
    addBtn() {
      this.$refs.manualAddDialog && this.$refs.manualAddDialog.open();
    },
    onManualAddSuccess() {
      this.activeStatusTab = String(PURCHASE_RECORD_STATUS.PENDING_CONFIRM);
      this.currentPage = 1;
      this.params.beginIndex = 0;
      this.cancelSelected();
      this.getData();
    },
    importData() {
      const upload = this.$refs.uploadPurchaseRecord;
      if (!upload || !(upload.uploadFiles || []).length) {
        this.$message.warning("请先选择导入文件");
        return;
      }
      this.importLoading = true;
      upload.submit();
    },
    onImportSuccess(res) {
      this.importLoading = false;
      this.dialogImportVisible = false;
      this.clearImportFiles();
      if (!res || (res.result !== 1 && res.code !== 0)) {
        this.$message.error((res && res.message) || "导入失败");
        return;
      }
      const msg = (res && res.message) || "导入完成";
      this.$message.success(msg);
      this.getData();
    },
    onImportError() {
      this.importLoading = false;
      this.$message.error("导入失败");
    },
    clearImportFiles() {
      const upload = this.$refs.uploadPurchaseRecord;
      if (upload && upload.uploadFiles && upload.uploadFiles.length) {
        upload.clearFiles();
      }
    },
    exportProductBtn() {
      if (!(this.multipleSelection || []).length) {
        this.$message.warning("请先选择采购记录");
        return;
      }
      this.dialogExportVisible = true;
      this.exportDataList = [];
      this.exportStoreDataList = [];
      requestModules.fetchExportPurchaseRecords(this.getExportParams()).then(res => {
        if (res.result !== 1) {
          this.$message.error(res.message || "导出失败");
          return;
        }
        this.exportDataList = [...(res.ldata || [])];
        this.exportStoreDataList = [...(res.ldata || [])];
        this.exportStoreDataList.sort((a, b) => {
          if (a.shopType == b.shopType) {
            return String(a.sku || "").localeCompare(String(b.sku || ""));
          }
          return (Number(a.shopType) || 0) - (Number(b.shopType) || 0);
        });
      });
    },
    exportMaterialBtn() {
      if (!(this.multipleSelection || []).length) {
        this.$message.warning("请先选择采购记录");
        return;
      }
      this.dialogExportMaterialVisible = true;
      this.exportMaterialLoading = true;
      this.exportMaterialDataList = [];
      requestModules
        .fetchExportPurchaseRecordMaterials(this.getExportParams())
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "导出材料失败");
            return;
          }
          this.exportMaterialDataList = [...(res.ldata || [])];
        })
        .catch(() => {
          this.$message.error("导出材料失败");
        })
        .finally(() => {
          this.exportMaterialLoading = false;
        });
    },
    doConfirm(rows) {
      this.$confirm(`确认对选中的 ${rows.length} 条采购记录执行「确认采购」？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          if (this.actionLoading) return;
          this.actionLoading = true;
          requestModules
            .confirmPurchaseRecords({
              selectedList: JSON.stringify(rows),
            })
            .then(res => {
              if (res.result !== 1) {
                this.$message.error(res.message || "确认采购失败");
                return;
              }
              this.$message.success("确认采购成功");
              this.cancelSelected();
              this.getData();
            })
            .catch(() => {
              this.$message.error("确认采购失败");
            })
            .finally(() => {
              this.actionLoading = false;
            });
        })
        .catch(() => {});
    },
    doVoid(rows) {
      this.$confirm(`确认作废选中的 ${rows.length} 条采购记录？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.actionLoading) return;
          this.actionLoading = true;
          requestModules
            .voidPurchaseRecords({
              selectedList: JSON.stringify(rows),
            })
            .then(res => {
              if (res.result !== 1) {
                this.$message.error(res.message || "作废失败");
                return;
              }
              this.$message.success("作废成功");
              this.cancelSelected();
              this.getData();
            })
            .catch(() => {
              this.$message.error("作废失败");
            })
            .finally(() => {
              this.actionLoading = false;
            });
        })
        .catch(() => {});
    },
    getData() {
      this.loading = true;
      const params = {
        ...this.params,
        statusTab: this.activeStatusTab === "all" ? "" : this.activeStatusTab,
      };
      params.productTypeList = JSON.stringify(this.productTypeList || []);
      params.supplierIdList = JSON.stringify((this.supplierIdList || []).map(id => id.toString()));
      params.productModel = this.params.productModel || "";

      if (this.date && this.date.length == 2) {
        params.beginDate = this.date[0].format("yyyy-MM-dd");
        params.endDate = this.date[1].format("yyyy-MM-dd");
      } else {
        params.beginDate = "";
        params.endDate = "";
      }

      requestModules
        .fetchPurchaseRecords(params)
        .then(res => {
          this.tableData = res.ldata || [];
          this.total = res.total || 0;
          this.multipleSelection = [];
        })
        .finally(() => {
          this.loading = false;
          this.relayoutTable();
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

#PurchaseRecordMgmt {
  .fulfillment-tip {
    margin: -4px 0 8px;
    padding: 0 4px;
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
  }

  .upload-demo {
    .el-upload__tip {
      line-height: 1.4;
      margin-top: 8px;
    }
  }

  .warning-text {
    color: #e6a23c;
  }

  .fulfillment-flag-empty {
    color: #c0c4cc;
  }
}
</style>
